import type { Locale } from "@commerce-frontend/i18n/types";
import { Container } from "@commerce-frontend/ui/base/Container/Container";
import { Section } from "@commerce-frontend/ui/base/Section/Section";
import { typography } from "@commerce-frontend/ui/base/Typography/typography";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import { getSkuFromSlug } from "@commerce-shared/utility";
import { useTranslations } from "next-intl";
import { useEnvVar } from "~/lib/config/context";
import { getIdByLocale } from "~/lib/review-channels";

type Props = {
	slug: string;
	locale: Locale;
};

export const ProductReviewsSection = ({ locale, slug }: Props) => {
	const t = useTranslations("ProductReviewsSection");
	const widgetIds = useEnvVar("NEXT_PUBLIC_REVIEW_WIDGET_IDS");
	const widgetId = getIdByLocale(locale, widgetIds);
	const sku = getSkuFromSlug(slug);

	if (!widgetId || !sku) {
		return null;
	}

	return (
		<Section>
			<Container>
				<div className="flex flex-col gap-7xl">
					<header className="flex flex-col gap-2xl">
						<h2 className={cn(typography("h2"))}>{t("title")}</h2>
						<p className={cn(typography("lead"))}>{t("subtitle")}</p>
					</header>
					<etrusted-widget data-etrusted-widget-id={widgetId} data-sku={sku} />
				</div>
			</Container>
		</Section>
	);
};
